import React from 'react';
import './plan_management.screen.scss';
import { Assets, Colors, Main } from 'utils/imports.utils';
import { useNavigate } from 'react-router-dom';
import { STRINGS } from 'constants/strings.constant';
import { TARGET_PRICE_PAISE } from 'utils/constant.utils';
import { formatPaiseToRupees } from 'utils/functions.utils';

// The one real payment model: a flat price per target image. Information only; payment happens at publish.
const PlanScreen = () => {
  const navigate = useNavigate();
  const copy = STRINGS.upgradePlan;

  return (
    <Main backgroundColor={Colors.screenBackground} isRenderOnlyLogo={false}>
      <div className="plan-container">
        <button className="plan-back" onClick={() => navigate(-1)}>
          <img src={Assets.arrow_left} alt="" />
          {copy.back}
        </button>

        <h1 className="plan-title">{copy.title}</h1>
        <p className="plan-subtitle">{copy.subtitle}</p>

        <div className="plan-card">
          <h2 className="plan-heading">{copy.planName}</h2>
          <p className="plan-subheading">{copy.planDescription}</p>

          <div className="plan-price-row">
            <span className="plan-price">{formatPaiseToRupees(TARGET_PRICE_PAISE)}</span>
            <span className="plan-unit">{copy.unit}</span>
          </div>
          <div className="plan-badges">
            <span className="plan-badge">{copy.gstNote}</span>
            <span className="plan-badge">{copy.validity}</span>
          </div>

          <div className="plan-divider" />
          <div className="plan-includes">{copy.includesHeading}</div>
          <ul className="plan-features">
            {copy.features.map((feature) => (
              <li key={feature} className="plan-feature-item">
                <img src={Assets.plan_tick} alt={copy.tickAlt} className="plan-tick-icon" />
                {feature}
              </li>
            ))}
          </ul>
        </div>

        <p className="plan-footer">
          {copy.footerPrefix}
          <a className="plan-footer-link" href="/support" onClick={(event) => { event.preventDefault(); navigate('/support'); }}>{copy.footerLink}</a>
        </p>
      </div>
    </Main>
  );
};

export default PlanScreen;
